import { BORDER_VISIBILITY, BPMN_ACTION_TYPE, COLORPIC_CONTEXT ,DROPSHADOW_VISIBILITY, FONTSTYLES_VISIBILITY, TEXT_EDITOR_VISIBILITY, SET_BPMN_TARS_VISIBILITY, BACKGROUND_MENU_VISIBILITY,ERROR_FONTSTYLES_VISIBILITY, SET_FUNCTIONS_LIST  } from './types';

const initialState = {
    bpmnActionType: null,
    bpmnTarsVisibility: false,
    functions: []
};
const common = (state = initialState, action: any) => {
    switch (action.type) {
        case BPMN_ACTION_TYPE:
            return { 
                ...state, 
                bpmnActionType: action.data,
                bpmnTarsVisibility: (action.data === "COMMIT" || action.data === "DISCARD") ? false : state.bpmnTarsVisibility,
            };
        case COLORPIC_CONTEXT: 
            return ( 
                {...state,
                    colorPickerContext:action.data
                    
            })
        case DROPSHADOW_VISIBILITY:
            return { ...state, dropShadowVisibility: action.data }
        case BACKGROUND_MENU_VISIBILITY:
            return { ...state, backgroundMenuVisibility: action.data}
        case BORDER_VISIBILITY:
            return { ...state, borderVisibility: action.data }
        case TEXT_EDITOR_VISIBILITY:
            return { ...state, textEditorVisibility: action.data }
        case FONTSTYLES_VISIBILITY:
            return { ...state, fontStylesVisibility: action.data }
        case ERROR_FONTSTYLES_VISIBILITY:
            return { ...state, errorFontStylesVisibility: action.data }
        case SET_BPMN_TARS_VISIBILITY:
            return {
                ...state,
                 bpmnTarsVisibility: action.data,
            }
        case SET_FUNCTIONS_LIST:
            return {
                ...state,
                functions: action.data,
            }
        default:
            return state;
    }
};
export default common;
